class HicomBreadcrumbs implements IHicomBreadcrumbs { 

    static sessionBreadcrumbs = "hicom-breadcrumbs";

    breadcrumbDivider: string;
    breadcrumbHistoryLength: number
    breadcrumbUnique: boolean

    constructor( divider:string, historyLength: number, unique: string) {
        this.breadcrumbDivider = divider;
        this.breadcrumbUnique = unique === "True";
    }

    getBreadcrumbs(id) {

        return JSON.parse(sessionStorage[HicomBreadcrumbs.sessionBreadcrumbs+'_'+id] || '[]');

    }

    pushCurrentBreadcrumb(id) {
        let thisDivider = this.breadcrumbDivider;
        let thisBreadcrumb = $('nav#' + id + ' .breadcrumb .breadcrumb-item:last');
        let localConfig = JSON.parse(sessionStorage['hicom-breadcrumbs_' + id] || '[]');
        let thisUrl = thisBreadcrumb.find('a').attr('href');
        let thisTitle = thisBreadcrumb.find('a').text();
        let thisActive = thisBreadcrumb.hasClass('active');
        let thisTextOnly = thisBreadcrumb.data('text-only');
        let breadcrumbData = {
            title: thisTitle,
            url: thisUrl,
            active: thisActive,
            divider: thisDivider,
            textonly: thisTextOnly
        };
        localConfig.push(breadcrumbData);

        if (this.breadcrumbUnique == true) {

            let deduplicated = localConfig.reduce((unique, item) => {
                if (!unique.some(i => i.url === item.url)) {
                    if (item.url !== breadcrumbData.url) {
                        unique.push(item);
                    }
                }

                return unique;
            }, []);

            deduplicated.push(breadcrumbData);
            console.log(deduplicated);

            sessionStorage['hicom-breadcrumbs_' + id] = JSON.stringify(deduplicated);
        }
        else {
            sessionStorage['hicom-breadcrumbs_' + id] = JSON.stringify(localConfig);
        }

    }

    renderBreadcrumbs(id) {
        console.debug('renderBreadcrumbs :: '+id)
        let sessionBreadcrumbs = this.getBreadcrumbs(id);

        let lastItem = $('nav#'+id+' .breadcrumb .breadcrumb-item:last')

        let breadcrumbItemBase = lastItem.clone();
     
        console.debug(sessionBreadcrumbs);

        let lastIndex = sessionBreadcrumbs.length - 1;

        let breadcrumbIndex = (sessionBreadcrumbs.length - this.breadcrumbHistoryLength) >= 0 ? (lastIndex - this.breadcrumbHistoryLength+1) : 0;

        // @ts-ignore
        for (i = breadcrumbIndex; i < lastIndex; i++) {
            let breadcrumbItem = breadcrumbItemBase.clone();
              // @ts-ignore
            let thisBreadcrumb = sessionBreadcrumbs[i];

            breadcrumbItem.removeClass('active').removeAttr('aria-page');

            if (thisBreadcrumb.textonly == "False") {

                breadcrumbItem.find('a').attr('href', thisBreadcrumb.url);
                breadcrumbItem.find('a').text(thisBreadcrumb.title);
            }
            else {
                breadcrumbItem.find('a').remove();
                breadcrumbItem.text(thisBreadcrumb.title);
            }

            lastItem.before(breadcrumbItem);

        }

        // Now setup last item

        let lastItemInSession = sessionBreadcrumbs[lastIndex];

        lastItem.find('a').remove();
        lastItem.text(lastItemInSession.title);

    }

}


